export default __webpack_public_path__ + "static/media/Jared-Bruder.d9f5b485.jpg";